import { render, staticRenderFns } from "./MultirisksFinalReportForm.vue?vue&type=template&id=198bd8ed&"
import script from "./MultirisksFinalReportForm.vue?vue&type=script&lang=js&"
export * from "./MultirisksFinalReportForm.vue?vue&type=script&lang=js&"
import style0 from "./MultirisksFinalReportForm.vue?vue&type=style&index=0&id=198bd8ed&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports